module.exports = __webpack_public_path__ + "static/img/manual-20.f22ed89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-20.png
// module id = xXV9
// module chunks = 4